import React, {useState} from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from "./LoadingSpinner";

const RequestButton = ({onRequest, disabled, loadingMessage, className = '', children}) => {

    const [running, setRunning] = useState(false);


    let btnClass = 'request-btn btn ';

    if (running) btnClass += 'no-click ';

    btnClass += className;

    return (
        <button disabled={disabled} className={btnClass} onClick={async() => {
            if (running) return;

            setRunning(true);

            await onRequest();

            await TB.wait(400);

            await setRunning(false)
        }}>
            {running ? (
                <span className="request-btn-loading">
                    <LoadingSpinner/>
                    <span>
                        {loadingMessage || 'Sending'}
                    </span>
                </span>
            ): children}
        </button>
    );
};

RequestButton.propTypes = {
    onRequest: PropTypes.func,
    disabled: PropTypes.any,
    loadingMessage: PropTypes.any,
    className: PropTypes.any
};

export default RequestButton;